<template>
	<div class="pages">
		<h1 class="flow">{{title}}!</h1>
		<h2 class="flow">{{tip2}}</h2>
		<h3 class="flow">{{tip}}</h3>
		<div class="but">
			<el-button round @click="toBack">返回上一页</el-button>
			<el-button type="primary" round @click="backIndex">返回首页</el-button>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		data() {
			return {
				title: 404,
				tip: 'Sorry, page not found',
				tip2: '小肥仔本仔提示您，您当前访问的页面不存在'
			}
		},
		created() {
			var title = this.$router.history.current.name
			if (title == '403') {
				this.title = title
				this.tip = 'Sorry, You do not have permission to view this page'
				this.tip2 = '小肥仔本仔提示您，您暂无权限访问当前页面'
			}
		},
		methods: {
			// 返回上一页
			toBack() {
				this.$router.back(-1)
			},
			backIndex() {
				this.$router.push('/')
			}
		}
	}
</script>

<style lang="less" scoped>
	.pages {
		background-image: linear-gradient(to bottom, #c4fcef, #adfceb, #94fce7, #77fce3, #4ffbdf);
		width: 100vw;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		animation: changeColor 10s linear infinite;

		h1 {
			font-size: 140px;
			font-weight: 700;
			text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
				rgba(61, 61, 61, 0.3) 3px 3px;
		}

		h2 {
			font-size: 30px;
			text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
				rgba(61, 61, 61, 0.3) 3px 3px;
			margin-bottom: 40px;
		}

		h3 {
			font-size: 24px;
		}

		.but {
			padding: 30px 0;
		}
	}

	@keyframes changeColor {
		0% {
			filter: hue-rotate(0deg) blur(0px);
		}

		50% {
			filter: hue-rotate(180deg) blur(1px);
		}

		100% {
			filter: hue-rotate(360deg) blur(0px);
		}
	}
</style>
